import styled from 'styled-components';

const Wrapper = styled.header`
  margin: 0 auto;
  width: 70%;
  max-width: 860px;
  padding: 0 5% 0px 5%;
  text-align: center;
`;

export default Wrapper;